"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterSoundEffectVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class CharacterSoundEffectVfxStepArgs {
    constructor(subjectId, key) {
        this.subjectId = subjectId;
        this.key = key;
        this.__typeName = "CharacterSoundEffect";
        this.id = (0, uuid_1.v4)();
    }
}
exports.CharacterSoundEffectVfxStepArgs = CharacterSoundEffectVfxStepArgs;
